import "./VideoInfo.scss";
import viewsImg from "../../assets/Icons/views.svg";
import likesImg from "../../assets/Icons/likes.svg";
export default function VideoInfo({
  title,
  channel,
  timestamp,
  views,
  likes,
  description,
}) {
  // const {video} = props.video;
  return (
    <div className="info-card">
      <div className="info-card__wrapper">
        <div className="info-card__header">
          <h1 className="info-card__title">{title}</h1>
          <div className="info-card__subheader">
            <div className="posted">
              <p className="posted__by">By {channel}</p>
              <p className="posted__date">
                {new Date(timestamp).toLocaleDateString("en-US")}
              </p>
            </div>
            <div className="counter">
              <div className="counter__card">
                <img src={viewsImg} alt="" />
                <p className="counter__text">{views}</p>
              </div>
              <div className="counter__card">
                <img src={likesImg} alt="" />
                <p className="counter__text">{likes}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="info-card__body">
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}
